const {local} = require('./js/local.js')
const {lambda} = require('./js/lambda.js')

const params = (new URL(document.location)).searchParams
let profileId = params.get('profileId')
if (profileId === null) profileId = '1556482021141343'

const validInput = /^\d{16,17}$/ //exactly 16 or 17 digits
if (!validInput.test(profileId) ) {
  const loadingIndicators = document.getElementsByClassName('ring-loader')
  for (let i = 0; i < loadingIndicators.length; i++) {
    loadingIndicators[i].innerHTML = '<p style="color: red;">Input Error: Invalid profile id</p>'
  }
} else {
  console.log(`process.env.NODE_ENV: ${process.env.NODE_ENV}`)
  console.log(`process.env.ENV: ${process.env.ENV}`)
  if (process.env.ENV === 'local') local()
  if (process.env.ENV === 'dev') lambda(profileId, 'dev')
  if (process.env.ENV === 'prod') lambda(profileId, 'prod')
}